
import './BouquetNoteWrite.css';
import React from "react";
import ribbons from '../assets/constants/ribbons.js';
import vases from '../assets/constants/vases.js';
import stickers from '../assets/constants/stickers.js';
import flowers from '../assets/constants/flowers.js';
import brickHeader from '../assets/images/brickHeader.png';
import leafCluster from '../assets/images/leafCluster.png';

function BouquetShare(props) {
        let to=props.to.replaceAll(" ", "%20");
        let from=props.from.replaceAll(" ", "%20");
        let note=props.note.replaceAll(" ", "%20");
        let selectedSticker=props.selectedSticker
        let selectedDisplay=props.selectedDisplay
        let selectedRibbon=props.selectedRibbon
        let selectedFlowers=props.selectedFlowers.join(",")

        let linkText="https://e-florals.com/foryou/"+to+"/"+from+"/"+note+"/"+selectedSticker+"/"+selectedDisplay+"/"+selectedRibbon+"/"+selectedFlowers
        let linkTextb="https://e-florals.com/yourbouquet/"+selectedDisplay+"/"+selectedRibbon+"/"+selectedFlowers

    function copyToClipboard() {
        let copyText=linkText
        navigator.clipboard.writeText(copyText)
    .then(() => {
      alert("Text copied to clipboard!");
    })
    .catch(err => {
      console.error("Failed to copy: ", err);
    });
    }

    return (
        <div>
            <img src={brickHeader} alt="e-florals flower shop sign on a white brick building" className="brickHeaderimage" />
            <div className="row">
                <div className="bouqeutShareTop">
                    <div className="flowersInVase">
                        <img className="bouquetShareleafClusterImage" src={leafCluster} alt="green leaf cluster"/>
                        {props.selectedFlowers.map((flower, index) => (
                            <img key={index} className={"flowerImageLarge flowerImage" + index} src={flowers[flower].img} alt={flowers[flower].name} />
                        ))}
                    </div>
                    <img className="selectedVase" src={vases[props.selectedDisplay].src} alt={vases[props.selectedDisplay].alt} />
                    <img className="selectedVase backSelectedVase" src={vases[props.selectedDisplay].backSrc} alt={vases[props.selectedDisplay].alt} />
                    <div className="ribbonOnVase">
                        <div className={ribbons[props.selectedRibbon].type==="small" ? "shareBouquetRibbonSmall" : " "} >
                        <img className="chosenRibbon outlineRibbonChosen" src={ribbons[props.selectedRibbon].outlineSrc} alt="outline of a bow" />
                        <img className="chosenRibbon" src={ribbons[props.selectedRibbon].src} alt={ribbons[props.selectedRibbon].alt} />
                    </div>
                    </div>
                    <div className="envelopeBox">
                        <div class="firstBlackTriangle"></div>
                        <div class="secondBeigeTriangle"></div>
                        <img className="bouquetShareSticker" src={stickers[props.selectedSticker].src} alt={stickers[props.selectedSticker].alt} />
                    </div>
                </div>
                <div>
                    <a className="href" href={linkText} rel="noreferrer" target="_blank">
                    <p className="navButton bouquetShareButton"> click to preview your bouquet as the receiver in a new tab </p>
                    </a>
                    <a className="href" href={linkTextb} rel="noreferrer" target="_blank">
                    <p className="navButton bouquetShareButton"> click to view just your bouquet in a new tab </p>
                    </a>
                    <p onClick={() => copyToClipboard()} className="navButton bouquetShareButton"> click to copy the share link </p>
                </div>
            </div>
        </div>
    )
}

export default BouquetShare;